var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.opened
    ? _c("share-outfit-modal", {
        attrs: { type: _vm.type || "outfit", id: _vm.sharedId },
        on: { close: _vm.closed }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e9eba91", { render: render, staticRenderFns: staticRenderFns })
  }
}